import { render, staticRenderFns } from "./ModalVideoItem.vue?vue&type=template&id=454885dd&scoped=true&"
import script from "./ModalVideoItem.vue?vue&type=script&lang=js&"
export * from "./ModalVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalVideoItem.vue?vue&type=style&index=1&id=454885dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454885dd",
  null
  
)

export default component.exports